var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{style:(_vm.styleColor),attrs:{"src":_vm.styleColor.iframeAdress,"width":"100%","height":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }